import { type CsvButlerItem } from '../../../hooks/use-stm-quick-order-store'

export const formatAddToCartLabel = (items: CsvButlerItem[]): string => {
  const brandCount = new Set(items.map(item => item.projectCode)).size
  const pieceCount = items.reduce((total, item) => total + item.quantity, 0)
  return `加入購物車（${brandCount} 品牌／${pieceCount} 件）`
}
